import { createFileRoute } from '@tanstack/react-router';

import { MaterialsPage } from '@/features/admin/MaterialsPage';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/materials')({
  beforeLoad: () => requireRouteAccess('/admin/materials'),
  component: MaterialsPage,
});
